<template>
  <div class="portlet">
    <div class="portlet-head">
      <h3><i class="fas fa-truck"></i> Dostawy do magazynu</h3>
      <div>
        <button class="btn btn-outline-secondary" @click="handleSearch">
          <i class="fas fa-sync"></i> Odśwież
        </button>
        <b-button variant="outline-primary" @click="showModalMaterials('zpz')">
          <i class="fas fa-plus"></i> Zwróć przyjęty materiał
        </b-button>
        <b-button variant="outline-primary" @click="showModalMaterials('pz')">
          <i class="fas fa-plus"></i> Przyjmij materiały
        </b-button>
      </div>
    </div>
    <div class="portlet-body">
      <div class="searchpanel">
        <b-form>
          <DatepickerWithDropdown
            class="datepicker"
            :selected="this.selectedRange"
            @input="range"
            :range="search.issue_date"
          />
        </b-form>
      </div>
      <b-table
        class="table table-list table-mobilepro bills-table"
        ref="delivery_table"
        :fields="fields"
        :busy.sync="isBusy"
        :items="deliveries"
        stacked="lg"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        empty-text="Brak Przyjętych Towarów"
        show-empty
      >
        <template v-slot:table-busy>
          <TableSpiner />
        </template>
        <template v-slot:empty="{ emptyText }">
          <div class="empty">
            <i class="empty-state fas fa-truck"></i>
            <span class="empty-search">{{ emptyText }}</span>
          </div>
        </template>
        <template v-slot:cell(issue_date)="data">
          <a style="cursor: pointer" @click="showDetails(data.item)">{{
            data.item.issue_date | date
          }}</a>
        </template>
        <template v-slot:cell(type)="data">
          <b-badge
            :variant="data.item.type == 'pz' ? 'success' : 'secondary'"
            >{{ types[data.item.type] }}</b-badge
          >
        </template>
        <template v-slot:cell(employee)="data"
          >{{ data.item.employee.firstname }}
          {{ data.item.employee.lastname }}</template
        >
        <template v-slot:cell(cost)="data">
          {{ data.item.cost.toFixed(2) }}
          <small>{{getMainBaseCurrency}}</small>
        </template>
        <template v-slot:cell(options)="data">
          <div class="text-right text-lg-center">
            <b-dropdown no-caret right variant="light" class="btn-rounded">
              <template v-slot:button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button @click="showDetails(data.item)"
                >Szczegóły zdarzenia</b-dropdown-item-button
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button
                class="danger"
                @click="confirmRemove(data.item)"
              >
                <i class="fas fa-trash-alt"></i> Usuń
              </b-dropdown-item-button>
            </b-dropdown>
          </div>
        </template>
      </b-table>
    </div>
    <ModalTakeMaterials
      :title="title"
      :btnSubmitText="submitText"
      :issuance="false"
      :type="selectedType"
      @submit="submitDelivery"
    />
    <ModalMaterialsEvent :event="selectedEvent" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DatepickerWithDropdown from "@/components/DatepickerWithDropdown";
import TableSpiner from "@/components/TableSpiner";
import ModalTakeMaterials from "@/components/warehouse/ModalTakeMaterials";
import ModalMaterialsEvent from "@/components/warehouse/ModalMaterialsEvent";
import dayjs from "dayjs";
import {formatDateTime} from "@/services/helpers";

export default {
  name: "TheDeliveries",
  components: {
    DatepickerWithDropdown,
    TableSpiner,
    ModalTakeMaterials,
    ModalMaterialsEvent,
  },
  data() {
    return {
      title: "",
      submitText: "",
      sortBy: "issue_date",
      selectedEvent: {},
      selectedType: "",
      sortDesc: true,
      isBusy: false,
      fields: [
        { key: "issue_date", label: "Data zdarzenia", sortable: true },
        { key: "type", label: "Rodzaj zdarzenia", sortable: true },
        { key: "employee", label: "Przyjęte przez" },
        {
          key: "quantity",
          label: "Ilość",
          class: "text-right",
        },
        {
          key: "cost",
          label: "Wartość",
          class: "text-right",
        },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
    };
  },
  filters: {
    date(value) {
      return formatDateTime(value, "YYYY-MM-DD HH:mm");
    }
  },
  computed: {
    ...mapGetters("deliveries", [
      "types",
      "search",
      "selectedRange",
      "deliveries",
      "search",
    ]),
    ...mapGetters("company", ["getMainBaseCurrency"]),
  },
  methods: {
    ...mapActions("deliveries", ["doSearch", "remove", "create"]),
    showModalMaterials(type) {
      if (type === "zpz") {
        this.title = "Zwróć towar z magazynu";
        this.submitText = "Zwróć materiały";
        this.selectedType = "zpz";
      } else {
        this.title = "Przyjmij towar do Magazynu";
        this.submitText = "Dodaj materiały do magazynu";
        this.selectedType = "pz";
      }
      this.$nextTick(() => {
        this.$bvModal.show("take-materials-modal");
      });
    },
    showDetails(event) {
      this.selectedEvent = event;
      this.$nextTick(() => {
        this.$bvModal.show("materialevent-modal");
      });
    },
    confirmRemove(delivery) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć przyjęcie towaru ",
              h("br"),
              h("strong", [
                "z dnia ",
                dayjs(delivery.issue_date).format("YYYY-MM-DD"),
              ]),
              " ?",
              h("br"),
              h("br"),
              h("small", "Stan magazynu nie ulegnie zmianie."),
            ]),
          ],
          {
            title: "Potwierdź usunięcie wydania towaru",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.remove(delivery.id).then(() => {
            this.$refs.delivery_table.refresh();
          });
        });
    },
    range(range, selected) {
      if (range) {
        this.$store.commit("deliveries/range", {
          selected: selected,
          range: range,
        });
        this.handleSearch();
      }
    },
    handleSearch() {
      this.isBusy = true;
      this.$Progress.start();
      this.doSearch(this.search)
        .then(() => {
          this.isBusy = false;
        })
        .catch(() => {
          this.isBusy = false;
          return [];
        });
    },
    submitDelivery(form) {
      this.$Progress.start();
      this.create(form).then(() => {
        this.$refs.delivery_table.refresh();
        this.$nextTick(() => {
          this.$bvModal.hide("take-materials-modal");
        });
      });
    },
  },
};
</script>
